// WeeklyBreakdownCharts.tsx
import React from 'react';
import styles from './WeeklyBreakdownCharts.module.scss';
import { QuantityByStatusChart } from './Charts/QuantityByStatusChart';
import ClientsAndPetsChart from './Charts/ClientsAndPetsChart';
import NetSalesChart from './Charts/NetSalesChart';
import TotalBookingsChart from './Charts/TotalBookingsChart';
import type { WeeklyBreakdownReport } from 'model/BookingsWeeklyBreakdownReport';

interface Props {
    loading: boolean;
    report: WeeklyBreakdownReport;
}

export const WeeklyBreakdownCharts: React.FC<Props> = ({ loading, report }) => {
    return (
        <div className={styles.root}>
            <div className={styles.totalBookings}>
                <TotalBookingsChart
                    loading={loading}
                    report={report}
                />
            </div>

            <div className={styles.grid}>
                <QuantityByStatusChart
                    loading={loading}
                    report={report}
                />
                <ClientsAndPetsChart
                    loading={loading}
                    report={report}
                />
                <NetSalesChart
                    loading={loading}
                    report={report}
                />
            </div>
        </div>
    );
};

export default WeeklyBreakdownCharts;
